export enum HomeActionTypes {
	FILTER_LOCATION = 'FILTER_LOCATION',
	FETCH_EMPLOYEES_START = 'FETCH_EMPLOYEES_START',
	FETCH_EMPLOYEES_SUCCESS = 'FETCH_EMPLOYEES_SUCCESS',
	FETCH_EMPLOYEES_FAILURE = 'FETCH_EMPLOYEES_FAILURE',
	HOME_TAB_SELECTION = 'HOME_TAB_SELECTION',
	HOME_SHOW_TAB = 'HOME_SHOW_TAB'
}
